import React, { useContext, useState } from "react";
import ReactSwitch from "react-switch";
import ReceiptPrinter from "../../../assets/images/a33.png";
import SwitchContext from "../context";
import { Alert } from "@mui/material";

const FourthPage = () => {
  const { openValues, toggleSwitch, isOutOfStock, isUpperLimitReached } =
    useContext(SwitchContext);
  const [warning, setWarning] = useState("");
  return (
    <div>
      <div className="mb-3 flex justify-end">
        {warning && (
          <div className="flex justify-center items-center h-[0.1rem] m-5">
            <Alert variant="filled" severity="warning">
              {warning}
            </Alert>
          </div>
        )}
      </div>
      <div className="block md:flex md:justify-center md:items-center">
        <div className="w-full md:w-3/5">
          <p className="test text-xl md:text-3xl capitalize mb-4 font-medium">
            4. Receipt Printer
          </p>
          <div className="pl-0 md:pl-8 text-paragraph">
            <p className="mb-4 leading-relaxed">
              Uzeli uses a cloud connected thermal receipt printer to print
              receipts, daily closeout and staff reports. The receipt printer
              also controls the cash drawer to automatically open the drawer
              when a client chooses to pay by cash.
            </p>
          </div>
        </div>
        <div className="w-full md:w-2/5 flex flex-col">
          <img src={ReceiptPrinter} alt="" />
          <div className="flex items-center gap-4 justify-center w-full pt-7">
            <div className="flex flex-col items-center gap-y-0.5">
              <div className="text-xs">
                {openValues.ReceiptPrinter === 1
                  ? "Click to unselect"
                  : "Click to select"}
              </div>
            </div>
            <ReactSwitch
              onChange={() => {
                if (isOutOfStock("Growthzilla Cloud Receipt Printer")) {
                  setWarning("Currently out of stock");
                  setTimeout(() => {
                    setWarning("");
                  }, 2000);
                  return;
                } else if (
                  isUpperLimitReached("Growthzilla Cloud Receipt Printer")
                ) {
                  setWarning("Maximum quantity reached");
                  setTimeout(() => {
                    setWarning("");
                  }, 2000);
                  return;
                }
                toggleSwitch("ReceiptPrinter");
                window.GZAnalytics &&
                  window.GZAnalytics.customLog({
                    name: "Cart Items",
                    eventtype: "changed",
                    payload: {
                      ReceiptPrinter: !openValues.ReceiptPrinter,
                    },
                  });
              }}
              checked={openValues.ReceiptPrinter === 1}
              checkedIcon={false}
              uncheckedIcon={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthPage;
